module.exports = __webpack_public_path__ + "static/media/no_topic_image.cfb49f55.svg";